import React, { useEffect, useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  adminTagline,
  firstNameFromUser,
  homePathForUser,
  isTesoreroUser,
  welcomeShownKey,
} from '../config/roles';

const LOGO_ASDECYL = `${process.env.PUBLIC_URL || ''}/logo-asdecyl.jpg`;

const WelcomePage: React.FC = () => {
  const navigate = useNavigate();
  const { userId, displayName, email, entities, scoutGroupName, isAuthenticated } = useAuth();
  const tesorero = isTesoreroUser(entities);
  const name = firstNameFromUser(displayName, null, email);
  const groupLabel = scoutGroupName || entities.find((e) => e.role === 'tesorero')?.entity_name || 'tu grupo scout';
  const subtitle = tesorero ? `Tesorero/a del ${groupLabel}` : adminTagline(userId);
  const destination = homePathForUser(entities);
  const continueIn = useMemo(() => destination, [destination]);
  const doneRef = useRef(false);

  const goNext = () => {
    if (doneRef.current) return;
    doneRef.current = true;
    if (userId != null) {
      try {
        sessionStorage.setItem(welcomeShownKey(userId), '1');
      } catch {
        /* ignore */
      }
    }
    navigate(continueIn, { replace: true });
  };

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login', { replace: true });
      return;
    }
    const timer = window.setTimeout(goNext, 4200);
    return () => window.clearTimeout(timer);
  }, [isAuthenticated, userId]);

  return (
    <div className="min-h-screen scout-pattern flex items-center justify-center p-6">
      <div className="w-full max-w-lg rounded-3xl bg-white/95 border border-asde-purple/20 shadow-xl overflow-hidden text-center">
        <div className={`${tesorero ? 'bg-scout-green' : 'bg-asde-purple'} px-6 py-5 flex items-center justify-center gap-3`}>
          <img src={LOGO_ASDECYL} alt="ASDECYL" className="h-10 w-auto object-contain rounded" />
        </div>
        <div className="px-8 py-10">
          <p className="text-sm uppercase tracking-[0.2em] text-slate-500 font-semibold">Bienvenido</p>
          <h1 className={`mt-2 text-4xl sm:text-5xl font-bold ${tesorero ? 'text-scout-green-dark' : 'text-asde-purple-dark'}`}>
            {name}
          </h1>
          <p className="mt-4 text-lg sm:text-xl font-medium text-slate-700">{subtitle}</p>
          <button
            type="button"
            onClick={goNext}
            className={`mt-8 rounded-xl px-6 py-3 font-semibold text-white shadow-md ${
              tesorero ? 'bg-scout-green hover:bg-scout-green-dark' : 'bg-asde-purple hover:bg-asde-purple-light'
            }`}
          >
            Entrar
          </button>
          <p className="mt-3 text-xs text-slate-400">Entrando automáticamente…</p>
        </div>
      </div>
    </div>
  );
};

export default WelcomePage;
